import { useCssVars as _useCssVars, unref as _unref, defineComponent as _defineComponent } from 'vue'
import { ref, onMounted } from "vue";
import { Toast } from "vant";
import { useI18n } from "vue-i18n";
import { setAccountInfo } from "@/api/im";
import { md5 } from "@/uitls/uitls";

import { usePiniaState } from "@/store/userPinia";
interface dataProps {
    onClose: () => void;
}

export default /*#__PURE__*/_defineComponent({
  name: 'SetNickName',
  props: {
    onClose: { type: Function, required: true }
  },
  setup(__props: any, { expose }) {
  expose();

const props = __props as {
    onClose: () => void;
}

_useCssVars(_ctx => ({
  "0ca81913-btnTextColor": (btnTextColor.value),
  "0ca81913-btnColor": (btnColor.value)
}))

const { t } = useI18n();
const piniaStore = usePiniaState();
const { changeAccountInfo, user } = piniaStore;
const appName = process.env.VUE_APP_TITLE as string;
const primaryColor = '#91E71D';



const account = ref("");
const password = ref("");
const password2 = ref(""); // 密码确认
const nickname = ref(""); // 昵称
const email = ref("");

onMounted(() => {
    account.value = user.phone;
});

const verifyAccount = (str: string): boolean => {
    const regex = /^[A-Za-z][A-Za-z0-9]{5,19}$/;
    return regex.test(str) && /[A-Za-z]/.test(str) && /\d/.test(str);
}

const validatePassword = (str) => {
    const regex = /^[A-Za-z0-9!@#\$%\^&\*\(\)_\+\-=\[\]\{\};:'",.<>\/?\\|`~]{6,20}$/;
    return regex.test(str);
}

const doRegister = async () => {

    
    if(password.value.length == 0) {
        return Toast.fail(t('请输入密码'));
    }
    if(nickname.value.length == 0){
        return Toast.fail(t('请输入昵称'));
    }

    // if (!verifyAccount(account.value)) {
    //     return Toast.fail(t('me.accountInvalid'));
    // }
    // if (!validatePassword(password.value)) {
    //     return Toast.fail(t('me.pwsswordInvalid'));
    // }
    // // if (password2.value !== password.value) {
    // //     return Toast.fail(t('me.pwsswordNotSame'));
    // // }
    // if (nickname.value == '') {
    //     return Toast.fail(t('me.qsrnc'));
    // }

    const res: any = await setAccountInfo({
        fname: account.value,
        passwd: md5(password.value),
        nickname: nickname.value,
        email: email.value
    });
    console.log('set account info:', res);
    
    let retCode = res.status || res.ret;
    if (retCode == 0) {
        changeAccountInfo(res.fname, res.nickname, res.email);
        setTimeout(onClose, 1000);
        return Toast.success(t('me.setSucc'));
    } else if (retCode == 101) {
        return Toast.fail(t('me.accountInvalid'));
    } else if (retCode == 103) {
        return Toast.fail(t('me.nickNameErr'));
    } else if (retCode == 102) {
        return Toast.fail(t('me.accountRepeated'));
    } else if (retCode == 104) {
        return Toast.fail(t('me.nicknameRepeated'));
    } else {
        return Toast.fail(res.message);
    }
};



const btnColor = ref("#D0F29A");
const btnTextColor = ref("#878787");
const checkText = () => {
    if (account.value !== "" && password.value != "" && nickname.value != "") {
        btnColor.value = primaryColor;
        btnTextColor.value = "#101010";
        return
    }
};


const onClose = () => {
    if (props && props.onClose) {
        props.onClose();
    }
};


const __returned__ = { t, piniaStore, changeAccountInfo, user, appName, primaryColor, props, account, password, password2, nickname, email, verifyAccount, validatePassword, doRegister, btnColor, btnTextColor, checkText, onClose }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})